/* eslint-disable */
import React, { useEffect } from 'react';
import { t } from '@web-solutions/module-localization';
import Analytics from '@web-solutions/module-analytics';
import { useNav } from 'src/onboarding/hooks/nav';
import { useStore } from 'src/onboarding/store/store';
import { Screen, Title } from '../_shared/Screen';
import { PrimaryButton } from '../_shared/PrimaryButton';
import { trackFromGender, img } from '../_shared/hairstyleWomen';
import styles from './style.module.scss';

const BEFORE = ['guessing', 'unruly', 'morning', 'asking', 'doubting'];
const AFTER = ['knows', 'lowEffort', 'lifestyle', 'barber', 'sharper'];

function Page() {
  const { onNext, onPrev, currentIndex } = useNav();
  const gender = useStore((s: any) => s.hairstyleWomenGender);
  const track = trackFromGender(gender);
  const beforeImg = img(track, 'beforeAfter-before');
  const afterImg = img(track, 'beforeAfter-after');

  useEffect(() => {
    Analytics.trackEvent(`step${currentIndex + 1}`, 'view', { page: 'hairstyle-women-before-after' });
  }, []);

  const next = () => {
    Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', { page: 'hairstyle-women-before-after' });
    onNext();
  };

  return (
    <Screen
      progress={96}
      hideBack={currentIndex === 0}
      onBack={onPrev}
      footer={<PrimaryButton onClick={next}>{t('hairstyleWomenBeforeAfter.cta')}</PrimaryButton>}
    >
      <Title>{t('hairstyleWomenBeforeAfter.title')}</Title>
      <div className={styles.cols}>
        <div className={`${styles.col} ${styles.before}`}>
          <h2 className={styles.colTitle}>{t('hairstyleWomenBeforeAfter.beforeTitle')}</h2>
          <ul className={styles.list}>
            {BEFORE.map((b) => (
              <li key={b} className={styles.item}>
                <span className={`${styles.mark} ${styles.markBad}`} aria-hidden="true">✕</span>
                {t(`hairstyleWomenBeforeAfter.before.${b}`)}
              </li>
            ))}
          </ul>
          <div className={`${styles.photo} ${styles.photoBefore}`}>
            {beforeImg ? <img src={beforeImg} alt="" /> : <span className={styles.photoPh} aria-hidden="true" />}
          </div>
        </div>
        <div className={`${styles.col} ${styles.after}`}>
          <h2 className={styles.colTitle}>{t('hairstyleWomenBeforeAfter.afterTitle')}</h2>
          <ul className={styles.list}>
            {AFTER.map((a) => (
              <li key={a} className={styles.item}>
                <span className={`${styles.mark} ${styles.markGood}`} aria-hidden="true">✓</span>
                {t(`hairstyleWomenBeforeAfter.after.${a}`)}
              </li>
            ))}
          </ul>
          <div className={styles.photo}>
            {afterImg ? <img src={afterImg} alt="" /> : <span className={styles.photoPh} aria-hidden="true" />}
          </div>
        </div>
      </div>
    </Screen>
  );
}

export default Page;
